import gql from 'graphql-tag'

export default gql`
query {
  getCategories {
    id
    updated_at
    parent {
      id
      details {
        label
      }
    }
    details {
      id
      label
      language_id
    }
  }
}`



// WEBPACK FOOTER //
// ./src/apollo/graphql/category/getCategories.js